import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  standalone: false,
})
export class UserComponent implements OnInit {
  constructor(private transloco: TranslocoService) {}
  darkMode = false;
  invertColors = localStorage.getItem("isInverted") == "true";
  currentLanguage = { value: "it", label: "Italiano" };
  currentContrast = localStorage.getItem("colorAccessibility")
    ? parseInt(localStorage.getItem("colorAccessibility") ?? "100")
    : 100;
  currentZoom = { value: 1, label: "100%" };
  languages = [
    { value: "it", label: "Italiano" },
    // { value: "en", label: "English" },
  ];
  zoomAvailable = [
    { value: 0.25, label: "25%" },
    { value: 0.5, label: "50%" },
    { value: 0.75, label: "75%" },
    { value: 1, label: "100%" },
    { value: 1.25, label: "125%" },
    { value: 1.5, label: "150%" },
    { value: 1.75, label: "175%" },
    { value: 2, label: "200%" },
  ];

  ngOnInit(): void {
    let accessibility = localStorage.getItem("accessibility");
    if (accessibility) {
      this.currentZoom = JSON.parse(accessibility);
    }
    let language = localStorage.getItem("language");
    if (language) {
      this.currentLanguage = JSON.parse(language);
    }
    this.darkMode = localStorage.getItem("theme") === "dark" ? true : false;
  }
  changeTheme() {
    if (localStorage.getItem("theme") !== "dark") {
      localStorage.setItem("theme", "dark");
    } else {
      localStorage.setItem("theme", "base");
    }
    this.darkMode = localStorage.getItem("theme") === "dark" ? true : false;
    this.getTheme();
  }

  changeLanguage(language: any) {
    localStorage.setItem("language", JSON.stringify(language));
    this.transloco.setActiveLang(language.value);
    let html = document.getElementById("html");
    if (html && language) {
      html.lang = language?.value;
    }
  }

  changeZoom(item: any) {
    localStorage.setItem("accessibility", JSON.stringify(item));
    this.getAccessibility();
  }

  getAccessibility() {
    let accessibility: any = localStorage.getItem("accessibility");
    if (accessibility) {
      accessibility = JSON.parse(accessibility);
      document.body.style.setProperty(
        "--small",
        12 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--normal",
        14 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--medium",
        16 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--large",
        18 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--title",
        24 * accessibility?.value + "px"
      );
    }
  }
  getTheme() {
    let theme = localStorage.getItem("theme");
    switch (theme) {
      case "base":
        document.body.style.setProperty("--primary", "#47AD9F");
        document.body.style.setProperty("--secondary", "#102A35");
        document.body.style.setProperty("--tertiary", "#FFFFFF");
        document.body.style.setProperty("--quaternary", "#111111");
        break;
      case "dark":
        document.body.style.setProperty("--primary", "#102A35");
        document.body.style.setProperty("--secondary", "#47AD9F");
        document.body.style.setProperty("--tertiary", "#111111");
        document.body.style.setProperty("--quaternary", "#FFFFFF");
        break;
      default:
        document.body.style.setProperty("--primary", "#47AD9F");
        document.body.style.setProperty("--secondary", "#102A35");
        document.body.style.setProperty("--tertiary", "#FFFFFF");
        document.body.style.setProperty("--quaternary", "#111111");

        break;
    }
  }
  logout() {
    localStorage.clear();
    window.location.replace('');
  }

  changeColors(event?: any) {
    let body = document.getElementById("body");

    if (body) {
      if (event) {
        body.style.filter = `contrast(${event?.value}%)`;
        localStorage.setItem("colorAccessibility", event.value);
      } else {
        body.style.filter = `contrast(${localStorage.getItem(
          "colorAccessibility"
        )}%)`;
      }
    }
  }

  invert(event: any) {
    this.invertColors = event;
    let containerBody = document.getElementById("container-body");
    if (containerBody) {
      containerBody.style.filter = `${event ? "invert(100%)" : "invert(0)"}`;
      localStorage.setItem("isInverted", event);
    }
  }
}
